const ROOM_TAG_COOKIE_NAME = 'room_tag_v5';
const ROOM_TAG_COOKIE_EXPIRE_DAYS = 30;
const ROOM_TAG_COOKIE_SECURED = window.location.protocol === 'https:';

export const getRoomTag = () => {
  return App.es6.shared.cookie.get(ROOM_TAG_COOKIE_NAME);
};

export const setRoomTag = (value) => {
  if (!value) {
    throw new Error(`Tried to set room tag to falsy value: "${value}"`);
  }

  App.es6.shared.cookie.set(
    ROOM_TAG_COOKIE_NAME,
    value,
    ROOM_TAG_COOKIE_EXPIRE_DAYS,
    ROOM_TAG_COOKIE_SECURED,
  );
};

export const getPrettyRoomTag = () => {
  const roomTag = getRoomTag();

  if (!roomTag) {
    return Promise.resolve(null);
  }

  return new Promise((resolve) => {
    App.es6.shared.tags_storage().getTags().then(tags => {
      const tag = tags.tags
        .find(item => item.data.key === roomTag);

      resolve(tag?.value ?? null);
    });
  });
};
